import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { Product } from '../Product'

@InputType()
export class HasSubComponentsArgs extends ActionArgs {
  @Field(() => ID)
  productId: string

  @Field(() => Product)
  product?: Product
}

export interface IHasSubComponents extends IAction<boolean, HasSubComponentsArgs> {}
